module.exports = __webpack_public_path__ + "static/media/ACS.cdedb4fa.png";